import { traverseFog } from 'helpers';
import * as PIXI from 'pixi.js';
import * as setup from 'setup';

export default class Fog extends PIXI.Container {

    gameState: GameState;
    graphics: { [index: string]: PIXI.Graphics } = {};

    constructor(gameState: GameState) {
        super();

        // Initialize 
        this.alpha = gameState.settings.debugMap ? 0.2 : 1;
        this.gameState = gameState;
        this.scale.set(setup.map.cells.size);

        // Add grapics
        traverseFog((x, y) => {
            const cellName = `${x},${y}`;
            const graphic = new PIXI.Graphics();
            this.addChild(graphic);
            this.graphics[cellName] = graphic;
            graphic.label = cellName;
            graphic.rect(0, 0, 1, 1);
            graphic.fill({ color: 0, alpha: 1 });
            graphic.x = x;
            graphic.y = y;
        });
    }

    updateGameState = (gameState: GameState) => {
        this.gameState = gameState;
    }

    syncState = () => {
        Object.entries(this.graphics).forEach(([cellName, graphic]) => {
            graphic.visible = !!this.gameState.fog[cellName];
        });
    }

    revealCells = (cellNames: string[]) => {
        cellNames.forEach(cellName => {
            this.graphics[cellName].visible = false;
        });
    }

}